import React, { lazy, Suspense } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'

import Layout from 'layouts'

const routes = [
  // Public Pages
  {
    path: '/',
    Component: lazy(() => import('pages/public')),
    exact: true,
  },
  {
    path: '/apply',
    Component: lazy(() => import('pages/public/apply')),
    exact: true,
  },
  {
    path: '/apply-conventional',
    Component: lazy(() => import('pages/public/apply-conventional')),
    exact: true,
  },
  {
    path: '/success',
    Component: lazy(() => import('pages/public/success')),
    exact: true,
  },
  {
    path: '/published-pests',
    Component: lazy(() => import('pages/public/published-pests')),
    exact: true,
  },
  {
    path: '/approved-pesticides',
    Component: lazy(() => import('pages/public/approved-pesticides')),
    exact: true,
  },
  {
    path: '/progress/:id',
    Component: lazy(() => import('pages/public/progress')),
    exact: true,
  },
  {
    path: '/contact',
    Component: lazy(() => import('pages/public/contact-us')),
    exact: true,
  },

  // Dashboard
  {
    path: '/home',
    Component: lazy(() => import('pages/dashboard')),
    exact: true,
  },

  // Distribution Map
  {
    path: '/distribution-map',
    Component: lazy(() => import('pages/distribution-map')),
    exact: true,
  },
  // Master Pages
  {
    path: '/master',
    Component: lazy(() => import('pages/master')),
    exact: true,
  },
  {
    path: '/master/view/:id',
    Component: lazy(() => import('pages/master/view')),
    exact: true,
  },
  {
    path: '/master/create',
    Component: lazy(() => import('pages/master/create')),
    exact: true,
  },
  {
    path: '/master/update/:id',
    Component: lazy(() => import('pages/master/update')),
    exact: true,
  },
  // Pest Scouting
  // {
  //   path: '/farms',
  //   Component: lazy(() => import('pages/farms')),
  //   exact: true,
  // },
  // {
  //   path: '/country-pest/view/:id',
  //   Component: lazy(() => import('pages/scout')),
  //   exact: true,
  // },
  // Country Pest
  {
    path: '/country-pest',
    Component: lazy(() => import('pages/country-pest')),
    exact: true,
  },
  {
    path: '/country-pest/view/:id',
    Component: lazy(() => import('pages/country-pest/view')),
    exact: true,
  },
  // Commodities
  {
    path: '/commodities',
    Component: lazy(() => import('pages/commodities')),
    exact: true,
  },
  {
    path: '/commodities/view/:id',
    Component: lazy(() => import('pages/commodities/view')),
    exact: true,
  },
  {
    path: '/commodities/categories',
    Component: lazy(() => import('pages/commodities/categories')),
    exact: true,
  },
  {
    path: '/commodities/plant-parts',
    Component: lazy(() => import('pages/commodities/plant-parts')),
    exact: true,
  },
  // Presence
  {
    path: '/configuration/presence',
    Component: lazy(() => import('pages/configuration/presence/index')),
    exact: true,
  },
  // Phytosanitary Status
  {
    path: '/configuration/phytosanitary-status',
    Component: lazy(() => import('pages/configuration/phytosanitary-status/index')),
    exact: true,
  },

  // Countries
  {
    path: '/configuration/countries',
    Component: lazy(() => import('pages/configuration/countries/index')),
    exact: true,
  },

  // Counties
  {
    path: '/configuration/counties',
    Component: lazy(() => import('pages/configuration/counties/index')),
    exact: true,
  },

  // Sub Counties
  {
    path: '/configuration/sub-counties',
    Component: lazy(() => import('pages/configuration/sub-counties/index')),
    exact: true,
  },

  // Wards
  {
    path: '/configuration/wards',
    Component: lazy(() => import('pages/configuration/wards/index')),
    exact: true,
  },

  // Requests
  {
    path: '/pest-alert/requests',
    Component: lazy(() => import('pages/requests/index')),
    exact: true,
  },

  // Pest Alert
  {
    path: '/pest-alert/experts',
    Component: lazy(() => import('pages/experts')),
    exact: true,
  },
  {
    path: '/pest-alert/notifications',
    Component: lazy(() => import('pages/pest-notifications')),
    exact: true,
  },

  // Branches
  {
    path: '/configuration/regions',
    Component: lazy(() => import('pages/configuration/regions/index')),
    exact: true,
  },

  // Life Form
  {
    path: '/configuration/life-form',
    Component: lazy(() => import('pages/configuration/life-form/index')),
    exact: true,
  },

  // Farms
  {
    path: '/pest-scouting/farms',
    Component: lazy(() => import('pages/farms')),
    exact: true,
  },

  // Projects
  {
    path: '/pest-scouting/projects',
    Component: lazy(() => import('pages/projects')),
    exact: true,
  },
  {
    path: '/pest-scouting/projects/:id',
    Component: lazy(() => import('pages/projects/view')),
    exact: true,
  },

  // Scouts
  {
    path: '/pest-scouting/scouts',
    Component: lazy(() => import('pages/scouts')),
    exact: true,
  },

  // Users
  {
    path: '/users/all-users',
    Component: lazy(() => import('pages/users/index')),
    exact: true,
  },
  {
    path: '/users/kephis-users',
    Component: lazy(() => import('pages/users/kephis-users/index')),
    exact: true,
  },

  {
    path: '/users/permissions',
    Component: lazy(() => import('pages/users/permissions')),
    exact: true,
  },
  {
    path: '/users/roles',
    Component: lazy(() => import('pages/users/roles')),
    exact: true,
  },
  {
    path: '/users/roles/create',
    Component: lazy(() => import('pages/users/roles/create')),
    exact: true,
  },
  {
    path: '/users/roles/update/:id',
    Component: lazy(() => import('pages/users/roles/update')),
    exact: true,
  },
  {
    path: '/users/permission-group',
    Component: lazy(() => import('pages/users/permission-group')),
    exact: true,
  },

  // Biopesticide application

  {
    path: '/biopesticides/applications',
    Component: lazy(() => import('pages/biopesticides/applications')),
    exact: true,
  },
  {
    path: '/biopesticides/applicant-status',
    Component: lazy(() => import('pages/biopesticides/applicant-status')),
    exact: true,
  },
  {
    path: '/biopesticides/category',
    Component: lazy(() => import('pages/biopesticides/biopesticide-category')),
    exact: true,
  },
  {
    path: '/biopesticides/hazard-class',
    Component: lazy(() => import('pages/biopesticides/hazard-class')),
    exact: true,
  },
  {
    path: '/biopesticides/la-status',
    Component: lazy(() => import('pages/biopesticides/la-status')),
    exact: true,
  },
  {
    path: '/biopesticides/product-category',
    Component: lazy(() => import('pages/biopesticides/product-category')),
    exact: true,
  },

  {
    path: '/biopesticides/purpose',
    Component: lazy(() => import('pages/biopesticides/purpose-of-application')),
    exact: true,
  },
  {
    path: '/biopesticides/types-of-use',
    Component: lazy(() => import('pages/biopesticides/types-of-use')),
    exact: true,
  },
  {
    path: '/biopesticides/applications/:id',
    Component: lazy(() => import('pages/biopesticides/applications/view')),
    exact: true,
  },

  // Addendums

  {
    path: '/documents/addendums',
    Component: lazy(() => import('pages/documents/addendums')),
    exact: true,
  },
  {
    path: '/documents/addendums/:id',
    Component: lazy(() => import('pages/documents/addendums/view')),
    exact: true,
  },

  // Sps

  {
    path: '/documents/sps',
    Component: lazy(() => import('pages/documents/sps')),
    exact: true,
  },
  {
    path: '/documents/sps/:id',
    Component: lazy(() => import('pages/documents/sps/view')),
    exact: true,
  },

  // Pra

  {
    path: '/documents/pra',
    Component: lazy(() => import('pages/documents/pra')),
    exact: true,
  },
  {
    path: '/documents/pra/:id',
    Component: lazy(() => import('pages/documents/pra/view')),
    exact: true,
  },

  // Reports
  {
    path: '/reports/master/list',
    Component: lazy(() => import('pages/reports/master/master-pest-list')),
    exact: true,
  },
  {
    path: '/reports/country/list',
    Component: lazy(() => import('pages/reports/country/country-pest-list')),
    exact: true,
  },

  // Auth Pages
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
  },
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },
]

const mapStateToProps = ({ settings }) => ({
  routerAnimation: settings.routerAnimation,
})

const Router = ({ history, routerAnimation }) => {
  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                >
                  <Switch location={location}>
                    <Route exact path="/dashboard" render={() => <Redirect to="/dashboard" />} />
                    {routes.map(({ path, Component, exact }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={() => {
                          return (
                            <div className={routerAnimation}>
                              <Suspense fallback={null}>
                                <Component />
                              </Suspense>
                            </div>
                          )
                        }}
                      />
                    ))}
                    <Redirect to="/auth/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
